<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="row col-12">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Identificação Facial
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-mt-md text-brand-5 text-weight-bold q-gutter-sm items-center"
    >
      <div>
        <q-toggle
          class="texto-toggle"
          v-model="livesCheck"
          label="LivenessCheck"
        />
      </div>
      <!--<div class="col-md-2 col-xs-8">
            <div class="q-ml-sm text-brand-5 texto-inputs">Selecionar Camera</div>
           
            <q-select
              v-model="deviceSelected"
              dense
              outlined
              class="select q-mt-sm q-mb-sm"
              label="Digite o nome para pesquisar"
              :options="devicesList"
              option-label="label"
              
            />
          </div>-->
    </div>

    <div class="print-container">
      <div
        v-if="verificado.result.code == 1009"
        class="column justify-center result-css q-mt-xl q-mb-md"
      >
        <span class="text-h6 text-weight-bold">Rosto não Identificado</span>
        <q-icon name="warning" color="negative" class="q-ml-sm" size="80px" />
      </div>

      <div v-if="!esconderCaptura" class="column result-css q-mt-xl q-mb-md">
        <span class="text-h6 text-weight-bold">{{
          verificado.ExternalID
        }}</span>
        <q-icon
          name="verified"
          v-if="sendSucess"
          color="positive"
          class="q-ml-sm"
          size="80px"
        />
      </div>

      <video v-if="esconderCaptura" class="faceCapture" autoplay></video>
      <q-btn
        v-if="esconderCaptura"
        label="Identificar"
        class="q-mt-md q-ml-sm"
        color="secondary"
        icon="visibility"
        @click="screenShot"
      />

      <canvas
        v-show="!esconderCaptura && sendSucess != true"
        style="height: 100%; width: 50%"
        class="canvasFace q-mt-md"
      ></canvas>
      <div v-if="!esconderCaptura" class="row q-mt-md">
        <q-btn
          v-if="sendSucess != true"
          label="Enviar"
          class="q-ml-sm"
          color="positive"
          icon="add"
          @click="VerificarFace"
        />
        <q-btn
          label="Tirar novamente"
          class="q-ml-sm"
          color="secondary"
          icon="refresh"
          @click="screenRepeat"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

export default {
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const verificado = ref({ ExternalID: "", result: { code: "" } });
    const devicesList = ref([]);
    const sendSucess = ref(false);
    const deviceSelected = ref("");
    const esconderCaptura = ref(true);
    const livesCheck = ref(false);
    const faceSend = ref(null);
    const contrains = ref({
      video: {
        width: {
          min: 1280,
          ideal: 1920,
          max: 1920,
        },
        height: {
          min: 720,
          ideal: 1080,
          max: 1080,
        },
      },
    });

    const getUserImage = async () => {
      const video = document.querySelector(".faceCapture");

      if (
        "mediaDevices" in navigator &&
        "getUserMedia" in navigator.mediaDevices
      ) {
        await navigator.mediaDevices
          .getUserMedia({
            ...contrains.value,
          })
          .then((stream) => {
            video.srcObject = stream;
            video.play();
          });
      }
    };

    onMounted(getUserImage);

    const screenShot = async () => {
      const canvas = document.querySelector(".canvasFace");
      const video = document.querySelector(".faceCapture");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext("2d").drawImage(video, 0, 0);
      canvas.src = canvas.toDataURL("image/webp");

      faceSend.value = canvas.toDataURL("image/jpeg", 0.9).slice(23);
      esconderCaptura.value = false;
    };

    const getDevices = async () => {
      const devices = await navigator.mediaDevices.enumerateDevices();

      devicesList.value = devices.filter((value) => {
        if (value.label != "") {
          return { id: value.deviceId, label: value.label };
        }
      });
    };

    onMounted(getDevices);

    const screenRepeat = async () => {
      verificado.value = { ExternalID: "", result: { code: "" } };
      sendSucess.value = false;
      esconderCaptura.value = true;

      if (
        "mediaDevices" in navigator &&
        "getUserMedia" in navigator.mediaDevices
      ) {
        const stream = await navigator.mediaDevices.getUserMedia({
          ...contrains.value,
        });
        const video = document.querySelector(".faceCapture");
        video.srcObject = stream;

        video.play();
      }
    };

    const VerificarFace = async () => {
      try {
        const response = await store.dispatch("facialStore/identificarFacial", {
          base64_image: faceSend.value,
          livesCheck: livesCheck.value,
        });

        verificado.value = response;

        quasar.notify({
          message: "Rosto identificado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        sendSucess.value = true;
      } catch (error) {
        verificado.value = { ExternalID: "", result: { code: 1009 } };
        quasar.notify({
          message: "Rosto não encontrado",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    return {
      getUserImage,

      devicesList,
      deviceSelected,

      verificado,
      screenShot,
      esconderCaptura,
      screenRepeat,
      VerificarFace,
      sendSucess,

      livesCheck,
    };
  },
};
</script>

<style scoped>
.print-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

video {
  width: 50%;
  height: 100%;
}

.result-css {
  align-items: center;
}
</style>
